export default __webpack_public_path__ + "static/floating-dark-43c3c72d67b512eae123f70921c2c74e8f6f7674579f837bf23e00e11680b42a.png";